// extracted by mini-css-extract-plugin
module.exports = {"conditions":"bd_fc","conditions__content":"bd_fd","conditions__footer":"bd_ff"};